export default __webpack_public_path__ + "static/media/easterWonderlandBgMob.3567ceeb.jpg";